import script from "./barCode.vue?vue&type=script&setup=true&lang=ts"
export * from "./barCode.vue?vue&type=script&setup=true&lang=ts"

import "./barCode.vue?vue&type=style&index=0&id=ad6c4c88&scoped=true&lang=scss"

import exportComponent from "D:\\project_h5\\mydyH5_Code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad6c4c88"]])

export default __exports__